/**
 * RowActions — اکشن‌های ردیفِ جدول، سازگار با موبایل.
 * دسکتاپ: دکمه‌های آیکونیِ کنارِ هم (مثل قبل).
 * موبایل: یک دکمهٔ «⋮» با ناحیهٔ لمسِ ≥۴۴px که منویی با عنوانِ واضحِ هر اقدام باز می‌کند.
 *
 * actions: [{
 *   key, label, icon, onClick,
 *   danger?, primary?, confirm?: "متنِ تأیید",
 *   hidden?: bool  — اکشنِ غیرمجاز اصلاً رندر نمی‌شود
 * }]
 */
import React from "react";
import { Button, Dropdown, Space, Tooltip, Popconfirm, Modal } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { Grid } from "antd";

const { useBreakpoint } = Grid;

export default function RowActions({ actions = [], size = "small" }) {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const visible = actions.filter((a) => a && !a.hidden);
  if (!visible.length) return null;

  if (isMobile) {
    const items = visible.map((a) => ({
      key: a.key,
      label: a.label,
      icon: a.icon,
      danger: a.danger,
    }));
    const onClick = ({ key, domEvent }) => {
      domEvent?.stopPropagation?.();
      const a = visible.find((x) => x.key === key);
      if (!a) return;
      if (a.confirm) {
        Modal.confirm({
          title: a.confirm,
          okText: "بله", cancelText: "خیر",
          okButtonProps: a.danger ? { danger: true } : undefined,
          onOk: () => a.onClick(),
        });
      } else a.onClick();
    };
    return (
      <Dropdown menu={{ items, onClick }} trigger={["click"]} placement="bottomLeft">
        <Button className="gx-row-actions-btn" icon={<MoreOutlined />}
          onClick={(e) => e.stopPropagation()} aria-label="اقدامات" />
      </Dropdown>
    );
  }

  return (
    <Space size={2}>
      {visible.map((a) => {
        const btn = (
          <Button size={size} danger={a.danger} type={a.primary ? "primary" : undefined}
            icon={a.icon} onClick={a.confirm ? undefined : (e) => { e.stopPropagation(); a.onClick(); }} />
        );
        const withTip = <Tooltip key={a.key} title={a.label}>{btn}</Tooltip>;
        if (a.confirm) {
          return (
            <Popconfirm key={a.key} title={a.confirm} okText="بله" cancelText="خیر"
              onConfirm={() => a.onClick()}>
              <span>{withTip}</span>
            </Popconfirm>
          );
        }
        return withTip;
      })}
    </Space>
  );
}
